import React from "react";
// REDUX
import { useSelector } from "react-redux";
// COMPONENTS
import ServersTable from "./ServersTable";
import ServersHeader from "./ServersHeader";
import ServersDrawer from "./ServersDrawer";
import ServersDeleteMOdal from "./ServersDeleteModal";
import ServerExport from "./ServerExportInfo";
// AUTHORIZATION
import validatePermission from "../../../utils/validatePermissions";
import UnauthorizedPage from "../../unauthorized/UnauthorizedPage";
import ServerImportFile from "./ImportFileComponent";
// INTERFACES
import { RootState } from "../../../app/store";

const ServersPage = () => {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */
	const { permissions } = useSelector((state: RootState) => state.user);
	const { theme } = useSelector((state: RootState) => state.home);

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************* */
	// USE EFFECT ************************************** */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div>
			{validatePermission("view-edge-management-servers", permissions) ? (
				<div>
					<div className={`layout__contentPage__${theme}`}>
						<ServersHeader />
						<ServersTable />
						<ServersDrawer />
						<ServersDeleteMOdal />
						<ServerExport />
						<ServerImportFile />
					</div>
				</div>
			) : (
				<UnauthorizedPage />
			)}
		</div>
	);
};

export default ServersPage;
